import { render, staticRenderFns } from "./AgendaPartialForm.vue?vue&type=template&id=4848e214"
import script from "./AgendaPartialForm.vue?vue&type=script&lang=js"
export * from "./AgendaPartialForm.vue?vue&type=script&lang=js"
import style0 from "./AgendaPartialForm.vue?vue&type=style&index=0&id=4848e214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports